module.exports = __webpack_public_path__ + "img/zhpic.4fad133c.png";